import { Route } from 'react-router-dom';
import { ListAlertsPage } from './list-alerts';
import { RequireAuth } from '/src/components';

export { ListAlertsPage };

export const alertsRoutes: React.ReactElement[] = [
  <Route
    path="/alerts"
    element={
      <RequireAuth>
        <ListAlertsPage />
      </RequireAuth>
    }
  />,
];
